
import { singularityStore } from "@/store/store";
import { TreeNode } from "@/types/tree";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class AddSectionButton extends Vue {
  @Prop()
  sectionId!: TreeNode["id"];

  addSection() {
    singularityStore.setSectionAddOrSwapPanelState({
      mode: "add",
      sectionIdToAddAfterOrSwap: this.sectionId
    });
    singularityStore.setSingularityLeftPanel("section_add_or_swap");
  }
}
